enum UrlsAddress {
    BASE = "/",
    // ACCOUNT
    SIGN_IN = "/sign-in",
    SIGN_UP = "/sign-up",
    SIGN_UP_CUSTOMER = "/sign-up-customer",
    SIGN_UP_COMPANY = "/sign-up-company",
    SIGN_UP_CANDIDATE = "/sign-up-candidate",
    SIGN_UP_CONSULTANT = "/sign-up-staff",
    FORGOT_PASSWORD = "/forgot-password",
    RESET_PASSWORD = "/reset-password",
    // DASHBOARD
    DASHBOARD = "/dashboard",
    // MOJ
    // MOJ = "/moj/:idMOJ",
    MOJ = "/moj",
    MOJ_DETAIL = "/moj-detail",
    // PROFILE
    PROFILE = "/profile",
    // PAYMENTS
    PAYMENT_FAILED = "/payment-failed",
    PAYMENT_SUCCESS = "/payment-success",
    // COMPANIES
    BUY_CREDITS = "/buy-credits",
    // CONSULTANTS
    STAFF = "/staff",
    CONSULTANT_PERMISSIONS = "/consultant-permissions",
    CONSULTANT_MOJS = "/consultant-mojs",
    INVITE_CANDIDATES = "/invite-candidates",
    INVITE_STAFF = "/invite-staff",
    CONSULTANT_MOJ_DETAIL = "/consultant-moj-detail",
    // INTERNAL CONSULTANTS
    INTERNAL_MOJ_REQUESTS = "/internal-moj-requests",
    INTERNAL_MANAGE_CREDITS_BRANCH = "/manage-credits-branch",
    INTERNAL_STAFF = "/internal-staff/:branch?",
    INTERNAL_MANAGE_BRANCHES = "/branches",
    INTERNAL_BRANCH_DETAIL = "/branch-detail",
    INTERNAL_FINANCIAL_DASHBOARD = "/financial-dashboard",
    INTERNAL_MANAGE_STAFF = "/manage-internal-staff/:idStaff",
    INTERNAL_MANAGE_STAFF_PERMISSIONS = "/manage-staff-permissions/:idStaff",
    INTERNAL_MANAGE_MOJ_COST = "/manage-moj-costs",
    INTERNAL_ADD_STAFF = "/add-staff",

    // GENERICS
    ACCESS_FORBIDDEN = "/access-forbidden",
    PAGE_NOT_FOUND = "/page-not-found",
}

export default UrlsAddress;
